export const CATEGORY_ROUTE = '/category/:categories([0-9a-z_\\-/]+)';
export const BRANCH_ROUTE = '/branch/:categories([0-9a-z_\\-/]+)';
export const PRODUCT_ROUTE = '/product/:categories([0-9a-z_\\-/]+)?/:productSlug([0-9a-z_\\-/]+)';
export const ORDER_ROUTE = '/quickorder';
